export default "__VITE_ASSET__CbdKI$uR__"